import React from 'react';
import { footerData, partyInfo } from '../data/mock';
import { IubendaCookiePolicy, IubendaPrivacyPolicy } from './IubendaIntegration';

export const Footer = () => {
  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_campaign-web-1/artifacts/4f5tl685_logopng.png" 
                alt="Io cambio insieme logo" 
                className="h-14 w-14 object-contain"
              />
              <span className="font-bold text-xl">{partyInfo.name}</span>
            </div>
            <p className="text-gray-400 leading-relaxed max-w-sm">
              {footerData.description}
            </p>
          </div>

          {/* Links Sections */}
          {footerData.sections.map((section) => (
            <div key={section.title}>
              <h3 className="font-bold text-lg mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      onClick={(e) => link.href.startsWith('#') && scrollToSection(e, link.href)}
                      className="text-gray-400 hover:text-cyan-400 transition-colors duration-200"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Privacy & Cookie Policy - Iubenda */}
          <div>
            <h3 className="font-bold text-lg mb-4">Privacy</h3>
            <ul className="space-y-2">
              <li className="text-gray-400 hover:text-cyan-400 transition-colors duration-200">
                <IubendaPrivacyPolicy />
              </li>
              <li className="text-gray-400 hover:text-cyan-400 transition-colors duration-200">
                <IubendaCookiePolicy />
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <p className="text-gray-400 text-sm text-center">
            © {new Date().getFullYear()} {partyInfo.name}. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
};
